<template>
  <div class="detail">
    <div class="borderc999 marg-bottom10">
      <van-search
        v-model="serachValue"
        placeholder="请输入搜索关键词"
        @search="goSearch()"
      />
    </div>

    <div class="marg-bottom10">
      <van-field
        v-model="name"
        label="姓名"
        placeholder="请输入姓名"
      />
    </div>
    <!-- 性别 -->
    <div class="van-cell van-field marg-bottom10">
      <div class="van-cell__title van-field__label"><span>性别</span></div>
      <div class="van-cell__value flexRow">
        <div class="marginRightXm">
          <van-radio-group
            v-model="sex"
            direction="horizontal"
          >
            <van-radio name="男">男</van-radio>
            <van-radio name="女">女</van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>
    <!-- 性别 -->

    <div class="marg-bottom10">
      <van-field
        v-model="mobile"
        type="number"
        label="手机号"
        placeholder="请输入手机号"
      />
    </div>
    <!-- 是否全职 -->
    <div class="van-cell van-field marg-bottom10">
      <div class="van-cell__title van-field__label"><span>是否全职</span></div>
      <div class="van-cell__value flexRow">
        <div class="marginRightXm">
          <van-radio-group
            v-model="full_time"
            direction="horizontal"
          >
            <van-radio name="0">兼职</van-radio>
            <van-radio name="1">全职</van-radio>

          </van-radio-group>
        </div>
      </div>
    </div>
    <!-- 是否全职 -->

    <!-- 职务 -->
    <div class="van-cell van-field marg-bottom10">
      <div class="van-cell__title van-field__label"><span>职务</span></div>
      <div
        class="van-cell__value flexRow"
        @click="dutyShow =true"
      >
        <div class="marginRightXm">
          {{job||'请选择职务'}}
        </div>
      </div>

    </div>
    <!-- /职务 -->

    <div class="marg-bottom10">
      <van-field
        v-model="idnumber"
        clearable
        label="身份证"
        placeholder="请输入身份证号码"
      />
    </div>
    <div class="marg-bottom10">
      <van-field
        v-model="passport"
        clearable
        label="护照"
        placeholder="请输入护照号码"
      />
    </div>
    <div class="marg-bottom10">
      <van-field
        v-model="price"
        clearable
        label="日薪"
        type="number"
        placeholder="请输入日薪"
      />
    </div>
    <div class="marg-bottom10">
      <van-field
        v-model="qty"
        clearable
        label="天数"
        type="number"
        placeholder="请输入天数"
      />
    </div>
    <div class="marg-bottom10">
      <van-field
        v-model="allowance"
        clearable
        type="number"
        label="补贴总额"
        placeholder="请输入补贴总额"
      />
    </div>
    <div class="marg-bottom10">
      <van-field
        v-model="bonus"
        type="number"
        clearable
        label="奖金总额"
        placeholder="请输入奖金总额"
      />
    </div>

    <div class="marg-bottom10">
      <van-field
        v-model="deduct"
        clearable
        type="number"
        label="扣除总额"
        placeholder="请输入扣除总额"
      />
    </div>

    <div class="van-cell van-field marg-bottom10">
      <div class="van-cell__title van-field__label"><span>支付凭证</span></div>
      <div class="van-cell__value flexRow">
        <div class="marginRightXm">
          <van-radio-group
            v-model="receipt"
            direction="horizontal"
          >
            <van-radio name="无票">无票</van-radio>
            <van-radio name="有票">有票</van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>

    <div class="van-cell van-field marg-bottom10">
      <div class="van-cell__title van-field__label"><span>支付方式</span></div>
      <div class="van-cell__value flexRow">
        <div class="marginRightXm">
          <van-radio-group
            v-model="payment"
            direction="horizontal"
          >
            <van-radio name="转账">转账</van-radio>
            <van-radio name="统一支付">统一支付</van-radio>
            <van-radio name="挂账">挂账</van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>

    <div class="marg-bottom10">
      <van-field
        v-model="bank"
        clearable
        label="开户行"
        placeholder="请输入开户行"
      />
    </div>

    <div class="marg-bottom10">
      <van-field
        v-model="bank_account"
        clearable
        label="银行账号"
        placeholder="请输入银行账户"
      />
    </div>

    <div class="marg-bottom10">
      <van-field
        v-model="project_team"
        clearable
        label="项目组"
        placeholder="请输入项目组"
      />
    </div>

    <div
      class="marg-bottom10"
      style="margin-bottom:60px"
    >
      <van-field
        v-model="remark"
        clearable
        label="备注"
        type="textarea"
        rows="1"
        autosize
        placeholder="请输入备注"
      />
    </div>

    <div class="footers">
      <van-button
        type="info"
        size="large"
        @click="onAdd()"
      >添加</van-button>
    </div>

    <!-- 假日伙伴选择弹出层 -->
    <van-popup
      v-model="serachShow"
      :style="{ height: '40%' ,width: '80%' }"
      round
      :closeable="true"
      @close="serachShow=false"
    >
      <div style="padding:20px 30px">

        <div class="boxs">
          <div
            v-for="(item,index) in searchList"
            :key="index"
            class="box-item"
            @click="onItem(item)"
          >
            {{item.name}}
          </div>
          <div
            v-show="searchList.length == 0"
            style="margin:auto"
          >
            <van-empty
              image="search"
              image-size="60"
              description="暂无搜索结果"
            />
          </div>
        </div>
      </div>
    </van-popup>
    <!-- /假日伙伴选择弹出层 -->

    <!-- 职位弹出层 -->
    <van-popup
      v-model="dutyShow"
      :style="{ height: '33%' ,width: '80%' }"
      round
      :closeable="true"
      @close="dutyShow=false"
    >
      <div style="padding:20px 30px">
        <div class="boxs">
          <div
            v-for="(item,index) in dutyList"
            :key="index"
            class="box-item"
            @click="addDuty(item)"
          >{{item}}</div>

        </div>

      </div>
    </van-popup>

  </div>
</template>
<script>
import { Dialog } from 'vant'
export default {
  data() {
    return {
      id: '',
      project_id: '',
      serachValue: '',
      serachShow: false,
      name: '',
      sex: '',
      mobile: '',
      full_time: '',
      idnumber: '',
      passport: '',
      project_team: '',
      price: 0,
      qty: 0,
      payment: '统一支付',
      allowance: 0,
      bonus: 0,
      deduct: 0,
      receipt: '无票',
      bank: '',
      bank_account: '',
      project_team: '',
      remark: '',
      job: '',
      searchList: [],
      dutyShow: false,

      dutyList: [
        '营长',
        '大队长',
        '中队长',
        '小队长',
        '协调员',
        '讲师',
        '摄影师',
        '其他',
      ],
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
  },
  methods: {
    goSearch() {
      this.$axios
        .post('partner/search', {
          keyword: this.serachValue,
        })
        .then((res) => {
          console.log(res)
          this.searchList = res.data.data
          this.serachShow = true
        })
    },
    onItem(item) {
      this.name = item.name
      this.sex = item.sex
      this.idnumber = item.idnumber
      this.mobile = item.mobile
      this.id = item.id
      this.project_team = item.project_team
      this.bank = item.bank
      this.passport = item.passport
      this.bank_account = item.bank_account
      this.serachShow = false
    },
    addDuty(item) {
      this.job = item
      this.dutyShow = false
    },
    onAdd() {
      if (!this.name) {
        this.$toast('请填写姓名')
        return
      }
      if (!this.sex) {
        this.$toast('请选择性别')
        return
      }
      if (!this.mobile) {
        this.$toast('请填写手机号')
        return
      }

      if (!this.idnumber && !this.passport) {
        this.$toast('请填写身份证或者护照号')
        return
      }

      this.$axios
        .post('partner/apply', {
          project_id: this.project_id,
          name: this.name,
          sex: this.sex,
          mobile: this.mobile,
          full_time: this.full_time,
          idnumber: this.idnumber,
          passport: this.passport,
          project_team: this.project_team,
          price: this.price,
          qty: this.qty,
          payment: this.payment,
          allowance: this.allowance,
          bonus: this.bonus,
          deduct: this.deduct,
          receipt: this.receipt,
          bank: this.bank,
          bank_account: this.bank_account,
          project_team: this.project_team,
          remark: this.remark,
          job: this.job,
        })
        .then((res) => {
          Dialog.alert({
            message: res.data.message,
          }).then(() => {
            this.$router.go(-1)
          })
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.detail {
  padding: 20px;
  background-color: #f7f7f7;
  .boxs {
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    text-align: center;
    .box-item {
      padding: 5px;
      display: inline-block;
      width: 45%;
      font-size: 18px;
      background: #f1f1f1;
      margin-top: 5px;
    }

    .box-item:after {
      content: '';
      width: 45%;
    }
  }
}


.marg-bottom10 {
  margin-bottom: 10px;
  // border-bottom: 1px solid #999;
}
.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
}
</style>